export const CREATE_COMMISSION_ROLE = "CREATE_COMMISSION_ROLE";
export const FETCH_COMMISSION_ROLES = "FETCH_COMMISSION_ROLES";
export const FETCH_COMMISSION_ROLE = "FETCH_COMMISSION_ROLE";
export const EDIT_COMMISSION_ROLE = "EDIT_COMMISSION_ROLE";
export const DELETE_COMMISSION_ROLE = "DELETE_COMMISSION_ROLE";
